import { render } from "./TelehealthProviderBase.vue?vue&type=template&id=b4dfbb5a&ts=true"
import script from "./TelehealthProviderBase.vue?vue&type=script&lang=ts"
export * from "./TelehealthProviderBase.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__